import { Box, Card, CardContent, Grid, Button, Stack, Typography, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Tooltip } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import First from "../../../assets/img/first1.gif";
import FirstStop from "../../../assets/img/protest_png.png";
import Running from "../../../assets/img/running.gif";
import RunningStop from "../../../assets/img/running_png.png";
import HeaderCustom from "../../../components/header/HeaderCustomStep";
import moment from 'moment-timezone';
import db, { firebase } from "../../../firebase-config"
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux';


const Root = styled(Box)(({ theme }) => ({
  background: "#0b0b0b",
  color: "#fff",
  width: "100%",
  height: "80px",
  //borderRadius: 16,
  padding: 16,
  paddingTop: 0,
  boxShadow: `0 8px 32px ${alpha("#000", 0.6)}`,
  marginTop: 5,
}));

const Label = styled("label")({
  fontSize: 44,
  color: "#fff",
});

const ValueLg = styled(Typography)({
  fontSize: 60,
  lineHeight: 1,
});

const Value = styled("span")({
  fontSize: 56,
  fontWeight: 900,
});

// Segmented bar (ทำได้ / คงเหลือ)
const BarWrap = styled(Box)(({ theme }) => ({
  position: "relative",
  height: 70,
  borderRadius: 14,
  overflow: "hidden",
  display: "flex",
  border: `1px solid ${alpha("#fff", 0.08)}`,
}));

const BarLeft = styled(Box)(({ percent }) => ({
  background: percent < 31 ? "#bd290b" : percent < 80 ? "#F4C542" : "#2e9281",
})); // yellow
const BarRight = styled(Box)({ background: "#E9E9E9", color: "#1b1b1b" });

const Pin = styled(Box)({
  position: "absolute",
  top: 0,
  width: 12,
  height: 12,
  borderRadius: 999,
  background: "#fff",
  boxShadow: `0 2px 0 ${alpha("#000", 0.35)}`,
});

const PercentText = styled(Typography)({
  position: "absolute",
  top: 20,
  transform: "translateX(-50%)",
  fontSize: 36,
  fontWeight: 900,
  color: alpha("#000", 0.7),
});

const SectionTitle = styled(Typography)({
  fontWeight: 900,
  fontSize: 46,
  color: "#c2c2c2",
  marginLeft: "0 !important",
  position: "relative",
  top: 12,
});

const SmallStat = ({ label, value, unit }) => (
  <Stack>
    <Typography
      sx={{
        fontSize: 40,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        lineHeight: 1,
      }}
    >
      {`${label} `}
      <Grid
        item
        display={"flex"}
        justifyContent={"end"}
        sx={{ minWidth: "57px" }}
      >
        <span style={{ fontSize: 44 }}>{value} </span>
      </Grid>
      {unit}
    </Typography>
  </Stack>
);
const SmallStatSecond = ({ label, value, unit }) => (
  <Stack>
    <Typography
      sx={{
        fontSize: 40,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "baseline",
        lineHeight: 1,
      }}
    >
      {`${label} `}
      <Grid
        item
        display={"flex"}
        justifyContent={"end"}
        sx={{ minWidth: "52px" }}
      >
        <span style={{ fontSize: 50, fontWeight: 900 }}>{value} </span>
      </Grid>
      {unit}
    </Typography>
  </Stack>
);

SmallStat.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  unit: PropTypes.string,
};

const CategoryCard = styled(Card)({
  background: alpha("#fff", 0.04),
  borderRadius: 16,
  border: `1px dashed ${alpha("#fff", 0.16)}`,
  color: "#fff",
  textAlign: "center",
});

const CategoryTitle = styled(Typography)({
  fontWeight: 900,
  fontSize: 50,
  textAlign: "center",
  lineHeight: 1.1,
});

const PercentBadge = styled(Box)({
  fontWeight: 900,
  fontSize: 48,
  display: "inline-flex",
  alignItems: "center",
  marginLeft: "10px",
});

const ProductionOMS = () => {
  const display = useSelector(state => state.auth.email);
  const { plant } = useParams();
  const [isRunning, setIsRunning] = useState(false);
  const [isHand, setIsHand] = useState(false);
  const [omsPork, setOmsPork] = useState([]);
  const [productionPlant, setProductionPlant] = useState([]);
  const [toggle, setToggle] = useState(true);
  const [open, setOpen] = useState();
  const [addProductinoPlant, setAddProductinoPlant] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddProductionPlant = (event) => {
    if (event.target.name === "production_plant") {
      setAddProductinoPlant(event.target.value);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setToggle((prev) => !prev);
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setIsRunning(true);
    setIsHand(true);
  }, []);

  const handleSubmitAddProductionPlant = async () => {
    try {
      const collectionName = "prod_mes_ignition_oms_pork_dashboard_1";
      const documentName = `${plant}.OMSPRODUCTIONPLANT`;

      const docRef = db.collection(collectionName).doc(documentName);

      if (!addProductinoPlant || isNaN(addProductinoPlant)) {
        alert("กรุณากรอก production plant เป็นตัวเลขที่ถูกต้อง!");
        return;
      }
      const data = {
        productionPlant: Number(addProductinoPlant),
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        user: display
      };


      await docRef.set(data);

      setAddProductinoPlant(null);
      setOpen(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดต production plant");
    }
  };

  useEffect(() => {
    const today = moment().format("YYYY-MM-DD");
    const omsPorksubscriber = db
      .collection("prod_mes_ignition_oms_pork_dashboard_1")
      .onSnapshot((querySnapshot) => {
        const omsPorkDocs = [];

        querySnapshot.forEach((doc) => {
          const data = { ...doc.data(), id: doc.id };
          if (doc.id.includes(today) && doc.id.includes(plant)) {
            omsPorkDocs.push(data);
          }
        });
        const lastomsPork = omsPorkDocs[omsPorkDocs.length - 1];
        if (lastomsPork) {
          setOmsPork(lastomsPork);
        } else {
          setOmsPork([]);
        }
      });

    const omsPorkproductionPlantsubscriber = db
      .collection("prod_mes_ignition_oms_pork_dashboard_1")
      .onSnapshot((querySnapshot) => {
        const productionPlantDocs = [];

        querySnapshot.forEach((doc) => {
          const data = { ...doc.data(), id: doc.id };
          if (doc.id.includes(`${plant}.OMSPRODUCTIONPLANT`)) {
            productionPlantDocs.push(data);
          }
        });
        const lastProductionPlant = productionPlantDocs[productionPlantDocs.length - 1];
        if (lastProductionPlant) {
          setProductionPlant(lastProductionPlant);
        } else {
          setProductionPlant([]);
        }
      });

    return () => {
      omsPorksubscriber();
      omsPorkproductionPlantsubscriber();
    };
  }, []);

  const backPart = omsPork?.dailyPlan?.productGroupYield?.productionLine?.backPart?.items ?? []
  const frontPart = omsPork?.dailyPlan?.productGroupYield?.productionLine?.frontPart?.items ?? []
  const middlePart = omsPork?.dailyPlan?.productGroupYield?.productionLine?.middlePart?.items ?? []
  const allowNames = ["เนื้อสะโพก", "เนื้อไหล่", "สันนอก", "สันใน"];
  const allowNames2 = ["สันคอ", "สามชั้น", "คอหมูย่าง", "ซี่โครงแผ่น"];

  const mergedParts = [
    ...backPart,
    ...frontPart,
    ...middlePart,
  ].filter(item => allowNames.includes(item.name));

  const mergedParts2 = [
    ...backPart,
    ...frontPart,
    ...middlePart,
  ].filter(item => allowNames2.includes(item.name));

  const fallbackParts = (names) =>
    names.map((name) => ({
      name,
      stdYield: null,
      actYield: null
    }));

  const dataToShow = toggle
    ? (mergedParts.length > 0 ? mergedParts : fallbackParts(allowNames))
    : (mergedParts2.length > 0 ? mergedParts2 : fallbackParts(allowNames2));

  const actualQty = omsPork?.dailyPlan?.dailyProductionPlan?.actualQty === undefined ? 0 : omsPork?.dailyPlan?.dailyProductionPlan?.actualQty
  const production = productionPlant?.productionPlant === undefined ? 0 : productionPlant?.productionPlant
  const targetQty = omsPork?.dailyPlan?.dailyProductionPlan?.targetQty === undefined ? 0 : omsPork?.dailyPlan?.dailyProductionPlan?.targetQty
  const avgCarcassWgh = omsPork?.dailyPlan?.productGroupYield?.avgCarcassWgh === undefined ? 0 : omsPork?.dailyPlan?.productGroupYield?.avgCarcassWgh

  const percentActual = (actualQty / production) * 100
  const remaining = production - actualQty
  const percentRemaining = actualQty ? 100 - ((actualQty / production) * 100) : 0;


  return (
    <>
      {/* Header */}
      <Grid item xs={12}>
        <HeaderCustom step={2}>CUT UP PROCESSING</HeaderCustom>
      </Grid>
      <Root>
        {/* Lots + Plan */}
        <Grid container spacing={2}>
          <Grid item xs={6} >
            <Grid container spacing={2} mt={0}>
              <Grid
                container
                xs={12}
                display={"flex"}
                alignItems={"baseline"}
                pl={3}
              >
                <Grid item xs={6}>
                  <Label>Lot ปัจจุบัน</Label>
                </Grid>
                <Grid item xs={6}>
                  <ValueLg>{omsPork?.stockLot?.currentLot?.lotNo === undefined ? '-' : omsPork?.stockLot?.currentLot?.lotNo}</ValueLg>
                </Grid>
              </Grid>
              <Grid
                container
                xs={12}
                display={"flex"}
                alignItems={"baseline"}
                pl={3}
              >
                <Grid item xs={6}>
                  <Label>Lot ก่อนหน้า</Label>
                </Grid>
                <Grid item xs={6}>
                  <ValueLg>{omsPork?.stockLot?.previousLot?.lotNo === undefined ? '-' : omsPork?.stockLot?.previousLot?.lotNo}</ValueLg>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Grid
              container
              spacing={2}
              sx={{
                textAlign: "center",
                marginTop: 0.5,
                border: `1px dashed ${alpha("#fff", 0.16)}`,
                borderRadius: 4,
              }}
            >
              <Grid
                item
                xs={6}
                sx={{
                  padding: "5px !important",
                  borderRight: `1px dashed ${alpha("#fff", 0.16)}`,
                }}
              >
                <Stack sx={{ lineHeight: 1.1 }}>
                  <Label>แผน</Label>
                  <Tooltip title="add production plant" arrow>
                    <Grid onClick={handleClickOpen}>
                      <Value>{production} </Value>
                      <Label>ตัว/วัน</Label>
                    </Grid>
                  </Tooltip>
                </Stack>
              </Grid>
              <Grid
                item
                xs={6}
                display={"flex"}
                alignItems={"center"}
                sx={{ padding: "5px !important" }}
              >
                <Stack
                  alignItems="center"
                  sx={{ lineHeight: 1.1, width: "100%" }}
                >
                  <Label>หมูเข้าตัดแต่ง (ชม. นี้)</Label>
                  <Grid>
                    <Value>{omsPork?.currentSpeedThisHour === undefined ? '-' : omsPork?.currentSpeedThisHour} </Value>
                    <Label>ตัว</Label>
                  </Grid>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Progress split bar */}
        <Stack
          spacing={1}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ px: 0.5, mb: 0.5 }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <img src={isHand ? First : FirstStop} width={80} />
            <SectionTitle sx={{ color: "#2e9281" }}>ทำได้</SectionTitle>
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <img
              src={isRunning ? Running : RunningStop}
              width={80}
              style={{ position: "relative", top: 5 }}
            />
            <SectionTitle>คงเหลือ</SectionTitle>
          </Stack>
        </Stack>
        <Box mt={2} />
        <BarWrap>
          <BarLeft percent={percentActual} sx={{ width: `${percentActual}%` }} />
          <BarRight sx={{ width: `${100 - percentActual}%` }} />

          {/* left number */}
          <Typography
            sx={{
              position: "absolute",
              left: 12,
              top: -4,
              fontWeight: 900,
              fontSize: 30,
            }}
          >
            {actualQty.toLocaleString()} ตัว
          </Typography>
          {/* right number */}
          <Typography
            sx={{
              position: "absolute",
              right: 12,
              top: -4,
              fontWeight: 900,
              fontSize: 30,
              color: "#6e6d6d",
            }}
          >
            {remaining} ตัว
          </Typography>

          {/* center pin + two percent labels like the first version */}
          <Pin sx={{ left: `calc(${percentActual}% - 6px)` }} />
          <PercentText
            sx={{
              left: `calc(${percentActual - 5}% + 6px)`,
              color: "#fff",
            }}
          >
            {Math.round(percentActual)}%
          </PercentText>
          <PercentText
            sx={{
              left: `calc(${percentActual + 5}% - 6px)`,
              color: alpha("#000", 0.55),
            }}
          >
            {Math.round(percentRemaining)}%
          </PercentText>
        </BarWrap>

        <Box mt={2} />

        {/* Category tiles */}
        <Grid container spacing={1}>
          {dataToShow?.map((c) => {
            const plant = ((actualQty * avgCarcassWgh) * (c.stdYield / 100)) / 1000
            const actual = c.weight / 1000
            const plantPercent = (plant / production) * 100;
            const actualPercent = (actual / actualQty) * 100;
            const percent = plant && actual ? (actual / plant) * 100 : 0
            const percentCal = actualPercent - plantPercent;
            let color = "#2e9281";
            if (Math.round(percent) < 90) {
              color = "#bd290b";
            } else if (Math.round(percent) >= 95 && Math.round(percent) <= 100) {
              color = "#2e9281";
            } else if (Math.round(percent) >= 90 && Math.round(percent) <= 94) {
              color = "#f6e65b";
            }
            return (
              <Grid item xs={3} key={c.name}>
                <CategoryCard>
                  <CardContent
                    sx={{ paddingTop: "2px", paddingBottom: "2px !important" }}
                  >
                    <CategoryTitle sx={{ color }}>{c.name}</CategoryTitle>
                    <Grid
                      sx={{
                        margin: "0 -15px",
                        padding: "10px 8px",
                        paddingBottom: 0,
                        borderTop: `1px dashed ${alpha("#fff", 0.16)}`,
                        borderRadius: 1.9,
                        lineHeight: 1,
                        paddingTop: "2px",
                      }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <SmallStat
                            label="เป้าหมาย"
                            value={plant === null ? 'NA' : plant?.toFixed(2)}
                            unit={"ตัน"}
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ marginTop: "-8px" }}>
                          <SmallStatSecond
                            label="ทำได้"
                            value={actual?.toFixed(2)}
                            unit={"ตัน"}
                          />
                        </Grid>
                      </Grid>
                      <PercentBadge>{percent > 100 ? 100 : Math.round(percent)}%</PercentBadge>
                    </Grid>
                  </CardContent>
                </CategoryCard>
              </Grid>
            );
          })}
        </Grid>
      </Root>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          Add Production Plant (ตัว/วัน)
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item md={6} xs={6}>
              <TextField
                fullWidth
                type="number"
                label="Production Plant (ตัว/วัน)"
                name="production_plant"
                required
                value={addProductinoPlant}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddProductionPlant}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>Cancel</Button>
          <Button disabled={!addProductinoPlant} onClick={() => { handleClose(false); handleSubmitAddProductionPlant(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProductionOMS;
